import { BaseElementDefBase, BaseElementDef } from "./BaseElementDef";
import { FormItem } from "@cs/FormItem";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { AbstractPayReceiptSettings } from "@/cs-ts-bridge/ts/abstract-pay-receipt-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class UtGovPayReceiptDef extends BaseElementDef<AbstractPayReceiptSettings, FormDefinitionItem<AbstractPayReceiptSettings>, FormItem> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<AbstractPayReceiptSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFUtGovPayReceipt"; // TODO - not hardcoded?
    }
}
